export default {"src":"/app/presentation/_next/static/media/blank.a6d38ead.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};